export default __webpack_public_path__ + "static/media/OJO DE TIGRE.85f08ccf.jpg";